import * as React from 'react'
import createSvgIcon from '../createSvgIcon'

export default createSvgIcon(
  <>
    <path d='M15.8264 11.0325L12.4252 14.4337C12.3116 14.545 12.159 14.6074 12 14.6074C11.841 14.6074 11.6884 14.545 11.5748 14.4337L8.17363 11.0325C8.08969 10.9469 8.03297 10.8383 8.01063 10.7205C7.98829 10.6027 8.00133 10.4809 8.04809 10.3705C8.09486 10.2601 8.17326 10.166 8.27342 10.1C8.37358 10.0341 8.49102 9.99931 8.61093 10L15.3891 10C15.509 9.99931 15.6264 10.0341 15.7266 10.1C15.8267 10.166 15.9051 10.2601 15.9519 10.3705C15.9987 10.4809 16.0117 10.6027 15.9894 10.7205C15.967 10.8383 15.9103 10.9469 15.8264 11.0325Z' />
  </>,
  'Caret'
)
